import { createHttpRouteInvoker } from '../../../../../shared/backend/transports/http';
import { auth } from '@/firebaseConfig';
import { backendConfig } from '../config';
import { normalizeApiError } from '../errors';

export const invokeHttpRoute = createHttpRouteInvoker({
  apiBaseUrl: backendConfig.apiBaseUrl,
  getIdToken: async () => auth.currentUser?.getIdToken(),
  normalizeApiError,
});
